// Module
var code = "<div class=\"block-7__image image\"></div> ";
// Exports
export default code;